import { gte } from "@ember/object/computed";
import { classNames } from "@ember-decorators/component";
import SingleSelectComponent from "select-kit/components/single-select";
import ComboBoxHeader from "./combo-box/combo-box-header";
import { pluginApiIdentifiers, selectKitOptions } from "./select-kit";
const ComboBox = dt7948.c(class ComboBox extends SingleSelectComponent {
  static {
    dt7948.g(this.prototype, "autoFilterable", [gte("content.length", 10)]);
  }
  #autoFilterable = (dt7948.i(this, "autoFilterable"), void 0);
}, [selectKitOptions({
  caretUpIcon: "caret-up",
  caretDownIcon: "caret-down",
  autoFilterable: "autoFilterable",
  clearable: false,
  headerComponent: ComboBoxHeader,
  shouldDisplayIcon: false
}), pluginApiIdentifiers(["combo-box"]), classNames("combobox", "combo-box")]);
export default ComboBox;